import { type AuthContext } from "../../src/auth/AuthContext";

const ROLES = ["Report Viewer"];
const ALLOWED_TAGS = ["web::access"];
const DENIED_TAGS = [];
const EFFECTIVE_TAGS = ALLOWED_TAGS.filter(t => !DENIED_TAGS.includes(t));
const EMAIL_ADDRESS = "test_user@test.qerent.ai";
const USER_ID = "e4a28f05-4532-4b61-8b79-3d233bc776b8";
const USER_NAME = "Test User";
const TENANT_DOMAIN = "test_tenant.qerent.ai";
const TENANT_NAME = "Test Tenant";
const ACCESS_TOKEN = "STUB_ACCESS_TOKEN";

export const DEFAULT_AUTH_CONTEXT: AuthContext = {
    allowedTags: ALLOWED_TAGS,
    deniedTags: DENIED_TAGS,
    effectiveTags: EFFECTIVE_TAGS,
    error: null,
    getIdTokenClaims: () => {},
    getTokenSilently: () => Promise.resolve(ACCESS_TOKEN),
    getTokenWithPopup: () => Promise.resolve(ACCESS_TOKEN),
    handleRedirectPromise: () => {},
    isAuthenticated: true,
    loading: false,
    loginWithPopup: () => {},
    loginWithRedirect: () => {},
    logout: () => {},
    onRedirectCallback: () => {},
    roles: ROLES,
    user: {
        name: USER_NAME,
    },
    userMetadata: {
        allowedTags: ALLOWED_TAGS,
        deniedTags: DENIED_TAGS,
        effectiveTags: EFFECTIVE_TAGS,
        domain: TENANT_DOMAIN,
        email: EMAIL_ADDRESS,
        EmailAddress: EMAIL_ADDRESS,
        name: USER_NAME,
        roles: ROLES,
        tenant_name: TENANT_NAME,
        user_id: USER_ID,
        UserId: USER_ID,
    },
};